import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class GatewayTenantService {

  private gatewayTenantAccountApiUrl = null;

  constructor(private http: HttpClient) {
    this.gatewayTenantAccountApiUrl = environment.gatewayTenantAccountApiUrl;
  }

  getCustomerId() {
    return sessionStorage.getItem('customerId');
  }

  createGatewayTenantAccount(): Observable<any> {
    const postReqBody = { customerId: this.getCustomerId() };
    return this.http.post(this.gatewayTenantAccountApiUrl, postReqBody );
  }

}
